import CompanyGroupDialog from './companyGroupDialog.container';

export default CompanyGroupDialog;
